export default () => {
    const nodeSelectors = {
        container: '[js-read-more="container"]',
        opener: '[js-read-more="opener"]',
        visibleText: '[js-read-more="visible-text"]',
        hiddenText: '[js-read-more="hidden-text"]',
    }
    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        jQuery(nodeSelectors.container).each(function () {
            let container = jQuery(this)
            let opener = container.find(nodeSelectors.opener)
            let visibleText = container.find(nodeSelectors.visibleText)
            let hiddenText = container.find(nodeSelectors.hiddenText)

            jQuery(opener).on('click', function() {
                hiddenText.fadeToggle(0)
                visibleText.fadeToggle(0)

                if( hiddenText.is(':visible') ) {
                    jQuery(opener).text('Read less')
                } else {
                    jQuery(opener).text('Read more')
                }
            })
        })
    }

    return Object.freeze({
        init,
    })
}